import { render, staticRenderFns } from "./VehicleRequestTypeCount.vue?vue&type=template&id=41f93b56&"
import script from "./VehicleRequestTypeCount.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestTypeCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports